<template>
  <v-layout class="panel details-panel flip-panel" row wrap>
    <v-flex xs12 md12 class="timeline-header">
      <v-icon>mdi-routes</v-icon>
      DETALHES DA FATURA
    </v-flex>
    <v-flex
      xs12
      md12
      v-if="transaction.payment_method === 'boleto'"
      class="details-panel purchase_detail"
    >
      <v-layout row wrap>
        <v-flex xs1 md1>
          <v-icon large color="green">mdi-file-document</v-icon>
        </v-flex>
        <v-flex xs2 md2>
          <p class="venc">VENCIMENTO</p>
          <p class="venc_data">
            {{ transaction.boleto_expiration_date | formatDate }}
          </p>
        </v-flex>
        <v-flex xs12 md12>
          <barcode width="1" height="55" :value="transaction.boleto_barcode">
            Show this if the rendering fails.
          </barcode>
        </v-flex>
      </v-layout>
      <!-- <div class="detail-object boleto">
                <div class="title">
                    CÓDIGO DE BARRAS
                </div>
                <div class="value">
                  23791.22928 60003.720566 75000.046906 5 80320000007092
                </div>
            </div> -->
      <div class="detail-object boleto">
        <div class="title">URL DO BOLETO</div>
        <div class="value paid">
          <a :href="transaction.boleto_url" target="_blank">{{
            transaction.boleto_url
          }}</a>
        </div>
      </div>
      <div v-if="transaction.payment_method === 'credit-card'" wrap>
        ID: {{ transaction.id }} - {{ transaction.payment_method }}
      </div>
    </v-flex>
  </v-layout>
</template>
<script>
import { EventBus } from "../../utils/event-bus";
import VueBarcode from "vue-barcode";
import moment from "moment";
export default {
  props: ["transaction_id"],
  data: () => ({
    transaction: {},
  }),
  components: {
    barcode: VueBarcode,
  },
  created() {},
  mounted() {
    EventBus.$on("transaction", (transaction) => {
      // console.log('LoadInvoices: ', invoices)
      this.transaction = transaction;
    });
  },
  filters: {
    formatDate: function (date) {
      if (!date) return "";
      else {
        return moment(date).format("DD/MM/YYYY");
      }
    },
  },
};
</script>
<style>
.details-panel.flip-panel {
  -webkit-perspective: 1000px;
  perspective: 1000px;
  position: relative;
}
@media screen and (min-width: 1200px) {
  .details-main .flip-panel {
    min-height: 440px;
  }
  .details-panel {
    /* background-color: transparent; */
    overflow: hidden;
  }
  .panel {
    margin-bottom: 22px;
    /* background-color: #fff; */
    border: 1px solid transparent;
    border-radius: 3px;
    padding-top: 20px;
    padding-left: 50px;
  }
}

.details-panel.purchase_detail {
  background-color: #fff;
  padding-top: 20px;
  padding-left: 20px;
}

.details-panel.purchase_detail .bloco {
  /* background-color: #FFF; */
  padding: 10px;
  margin-bottom: 22px;
  /* background-color: #fff; */
  border: 1px solid transparent;
  border-radius: 5px;
  padding-top: 20px;
  padding-left: 20px;
  background: #e2e2e2;
}

.details-panel .venc {
  font-size: 12px;
  border-bottom: 1px solid #cccccc;
}

.details-panel .venc_data {
  font-size: 12px;
  color: #808080;
}

.detail-object {
  padding: 0;
  margin-bottom: 20px;
}

.detail-object.boleto .title {
  font-size: 13px;
  width: 40%;
}
.detail-object > .title {
  color: #b0b0b0;
  font-style: italic;
  font-weight: 500;
  font-size: 14px;
  width: 80%;
  border-bottom: 1px solid #e2e2e2;
}
.detail-object > div {
  padding-left: 0px;
}

.detail-object.boleto .value {
  font-size: 16px;
  font-weight: 600;
  margin-top: 4px;
  opacity: 0.74;
}
.detail-object > .value:not(img) {
  height: 28px;
}
.detail-object > .value {
  color: #828282;
  font-size: 20px;
  word-wrap: break-word;
  margin-top: 8px;
}

.detail-object.status-url .value.paid {
  color: #3cb880;
}
</style>
